import React from "react";
import ReactDOM from "react-dom";

import "./pages/index.css";
import "../node_modules/rsuite/dist/styles/rsuite-default-rtl.css";
import "./index.css";
import App from "./pages";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();
